import { useEffect, useState } from "react";
import { getPublicConfig } from "../lib/config";

const CHIP = "h-6 px-2 rounded-md border border-border bg-white flex items-center text-[10px] font-bold";

function MethodChip({ id, label }) {
  switch (id) {
    case "card":
      return (
        <>
          <span className={CHIP} style={{ color: "#1A1F71" }} title="Visa">VISA</span>
          <span className={`${CHIP} gap-0.5`} title="Mastercard" aria-label="Mastercard">
            <span className="w-3 h-3 rounded-full bg-[#EB001B] inline-block" />
            <span className="w-3 h-3 rounded-full bg-[#F79E1B] -ml-1.5 inline-block" />
          </span>
        </>
      );
    case "apple_pay":
      return <span className={`${CHIP} !bg-[#111] !text-white !border-[#111]`} title="Apple Pay"> Pay</span>;
    case "google_pay":
      return <span className={CHIP} title="Google Pay"><span className="text-[#4285F4]">G</span>&nbsp;Pay</span>;
    case "klarna":
      return <span className={`${CHIP} !bg-[#FFB3C7] !border-[#FFB3C7] text-[#17120F]`} title="Klarna">Klarna</span>;
    case "paypal":
      return <span className={CHIP} style={{ color: "#003087" }} title="PayPal">PayPal</span>;
    case "customer_balance":
      return <span className={CHIP} title="Banküberweisung">Überweisung</span>;
    case "sepa_debit":
      return <span className={CHIP} title="SEPA-Lastschrift">SEPA</span>;
    case "link":
      return <span className={CHIP} style={{ color: "#00D66F" }} title="Link">Link</span>;
    case "giropay":
      return <span className={CHIP} style={{ color: "#003A7D" }} title="giropay">giropay</span>;
    case "sofort":
      return <span className={CHIP} title="Sofortüberweisung">Sofort</span>;
    default:
      return <span className={CHIP}>{(label || id).split(" ")[0]}</span>;
  }
}

export function ShippingDeadlineNote({ className = "" }) {
  const [days, setDays] = useState(null);
  useEffect(() => { getPublicConfig().then((c) => c && setDays(c.shipping?.deadline_days)); }, []);
  if (!days) return null;
  return (
    <p className={`text-xs text-muted-foreground ${className}`} data-testid="shipping-deadline-line">
      Versand durch den Verkäufer innerhalb von <span className="font-semibold text-foreground">{days} Tagen</span> nach Kauf.
    </p>
  );
}

export function PaymentMethodIcons({ methods, className = "", label }) {
  const [list, setList] = useState(methods || null);
  useEffect(() => {
    if (!methods) getPublicConfig().then((c) => c && setList(c.payment_methods));
    else setList(methods);
  }, [methods]);
  if (!list?.length) return null;
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="payment-method-icons">
      {label && <span className="text-[11px] text-muted-foreground mr-1">{label}</span>}
      {list.map((m) => <MethodChip key={m.id} id={m.id} label={m.label} />)}
    </div>
  );
}
